import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer4Ogrodzenia from "../../components/offer/4offerOgrodzenia";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Montaż ogrodzeń panelowych i siatkowych na działce | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Montaż ogrodzeń panelowych i siatkowych na działce | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Solidny montaż ogrodzeń panelowych, siatki ogrodzeniowej i podmurówek zabezpieczających działkę pod budowę lub ogród. Gdańsk, Gdynia, Wejherowo, Kartuzy, Kaszuby."
          key="desc"
        />
        <meta
          property="og:title"
          content="Montaż ogrodzeń panelowych i siatkowych na działce | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Solidny montaż ogrodzeń panelowych, siatki ogrodzeniowej i podmurówek zabezpieczających działkę pod budowę lub ogród. Gdańsk, Gdynia, Wejherowo, Kartuzy, Kaszuby."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer4Ogrodzenia />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
